import { styled } from '@mui/material';
import { SupportItemsContainer } from '../Support/Support.style';

export const Container = styled(SupportItemsContainer)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
`;
